import $ from 'jquery';

import {Analytics} from "@plaudit/analytics";
Analytics.setup(); // This will set up the system and return an instance of Analytics.

function onCheckFormConfirmation() {
	const confirmations = document.querySelectorAll(".analyticsFormConfirmation");
	for (let i=0; i < confirmations.length; i++) {
		const confirmation = confirmations[i];
		if (confirmation !== undefined && confirmation instanceof HTMLElement) {
			// Remove so it is not processed again
			confirmation.remove();

			// Process it
			const formTitle = confirmation.dataset.analyticsFormTitle;
			const formId = confirmation.dataset.analyticsFormId;
			const formType = confirmation.dataset.analyticsFormType;
			const analytics = Analytics.getInstance();
            if (formType === undefined) {
                console.warn("Form type is not defined for form confirmation", confirmation);
            } else {
			    analytics.trackEvent(formType, "Confirmation", `${formTitle} (ID: ${formId})`);
            }

            // Facebook and LinkedIn Conversions
            if (formId === "1") {
                // Contact Us Form
                if (window.lintrk !== undefined) {
                    window.lintrk('track', { conversion_id: 19214844 });
                    window.lintrk('track', { conversion_id: 19110228 });
                }
                if (window.fbq !== undefined) {
                    window.fbq('track', 'Lead');
                }
            } else if (formId === "2") {
                // Gated Content Form
                if (window.lintrk !== undefined) {
                    window.lintrk('track', { conversion_id: 19110236 });
                    window.lintrk('track', { conversion_id: 19214852 });
                }
                if (window.fbq !== undefined) {
                    window.fbq('track', 'Lead');
                }
            }
		}
	}
}

$(document).on("gform_confirmation_loaded", onCheckFormConfirmation);
$(document).on("frmFormComplete", onCheckFormConfirmation);
$(onCheckFormConfirmation);
